let hidden: 'hidden' | 'msHidden' | 'webkitHidden' | '',
  visibilityChange: 'visibilitychange' | 'msvisibilitychange' | 'webkitvisibilitychange' | '';

try {
  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
  } else if (typeof (document as any).msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
  } else if (typeof (document as any).webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  }
} catch {}

export function isDocumentHidden(): boolean {
  return (document as any)[hidden] as boolean;
}

export function handleVisibilityChange(callback: (hidden: boolean) => void): () => void {
  const wrappedCallback = () => callback(isDocumentHidden());
  const cancelListener = () => window.removeEventListener(visibilityChange, wrappedCallback, true);
  window.addEventListener(visibilityChange, wrappedCallback, true);
  return cancelListener;
}
